export function AnchorToc (pEditor, pAnchor)
{
  this.queryInsertTableOfContent = (pButton, command) =>
  {
    return ((BEditor.browser.isIE) ? true : pEditor.queryBasicCommandEnabled(pButton, 'inserthtml'));
  };


  this.insertTableOfContent = (pButton, command) =>
  {
    var i;
    var checkParentTagA = /^a$/i;
    var currentSelection = pEditor.range.selection.getCurrent();
    var currentRange = pEditor.range.getCurrent();

    if (currentSelection && currentRange)
    {
      var parentElementA = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);

      if (parentElementA)
      {
        if (BEditor.browser.isIE)
        {
          currentRange.moveToElementText(parentElementA);
          var movedCharacters, parentElement;

          do
          {
            currentRange.collapse(true);
            movedCharacters = currentRange.move('character', -1);
            parentElement = currentRange.parentElement();
          }
          while (parentElement == parentElementA && movedCharacters);

          currentRange.collapse(true);

          if (movedCharacters)
          {
            currentRange.move('character', 1);
          }

          parentElementA = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);

          if (parentElementA)
          {
            var tempNode = pEditor.iFrameDoc.createElement('SPAN');
            tempNode.innerHTML = '&nbsp;';
            parentElementA.parentNode.insertBefore(tempNode, parentElementA);
            currentRange.moveToElementText(tempNode);
            tempNode.removeNode(false);
          }

          currentRange.select();
        }
        else
        {
          currentRange.selectNode(parentElementA);
          currentRange.collapse(true);
          currentSelection.collapse(currentRange.startContainer, currentRange.startOffset);
        }
      }

      var strList = '<ul>';
      var anchorsList = pAnchor.getAnchorsList();

      for (i = 0; i < anchorsList.length; i++)
      {
        strList += '<li><a href="#' + anchorsList[i].anchorName + '"' + (isIE ? ' data-anchorhref="#' + anchorsList[i].anchorName + '"' : '') + '>' + anchorsList[i].anchorName + '</a></li>';
      }

      strList += '</ul>';
      pEditor.helpers.insertHTML(strList);
    }
  };
}